import React from "react"
import { useIntl } from "react-intl"

import FullPageMessage from "../FullPageMessage/FullPageMessage"

const MaintenanceModal = () => {
  const intl = useIntl()
  return (
    <FullPageMessage
      imgSrc="/images/illust/maintenance.svg"
      header={intl.formatMessage({
        id: "support.maintenance.header",
        defaultMessage: "We’re temporarily grounded",
      })}
      text={intl.formatMessage({
        id: "support.maintenance.text",
        defaultMessage:
          "We’re conducting routine maintenance at the moment. We’ll be online in a bit. Come back soon, ok?",
      })}
    />
  )
}

export default MaintenanceModal
